import { NavLink } from 'react-router-dom'
import { REPORT_CATALOG } from './reportCatalog'

/**
 * Moves between the reports a role can open. Each role keeps its reports
 * under its own prefix, so the links stay inside the workspace the reader is in.
 */
export default function ReportTabs({ base }: { base: string }) {
  return (
    <nav aria-label="Reports" className="print:hidden">
      <ul className="flex flex-wrap gap-2">
        {REPORT_CATALOG.map((report) => (
          <li key={report.id}>
            <NavLink
              to={`${base}/${report.id}`}
              className={({ isActive }) =>
                `flex min-h-11 items-center rounded-control border px-4 text-small font-bold ${
                  isActive ? 'border-primary bg-selected' : 'border-line-strong hover:bg-surface-2'
                }`
              }
            >
              {report.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
